import { useAtomValue } from "jotai";
import { ADMIN_LOGIN } from "../lib/paths.js";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { authAtom } from "../lib/auth-store.js";

/**
 * 未登录 → 跳 /login，记录 redirect 来源。
 * 已登录 → 渲染子路由。
 */
export function ProtectedRoute(): JSX.Element {
  const auth = useAtomValue(authAtom);
  const location = useLocation();
  if (!auth) {
    return <Navigate to={ADMIN_LOGIN} replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}
